import React, { useContext } from 'react';
import Select from '../../../../components/shared/InputElements/Select';
import UserPrefsContext from '../../../../context/UserPrefs/UserPrefsContext';
import { FormattedMessage } from 'react-intl';

const SelectChargingPattern = ({
  chargingPatterns,
  chargingPatternsId,
  label,
}) => {
  const userPrefs = useContext(UserPrefsContext);
  const idKey = chargingPatternsId ?? 'chargingPatternId';
  const chargingPatternId = userPrefs.get(idKey);

  // NOTE: If necessary, create translations for each pattern id. So far, using the own title
  return (
    <Select
      id="home-charging-advisor-charging-pattern"
      value={chargingPatternId}
      optionNames={chargingPatterns.map((p) => p.title)}
      optionValues={chargingPatterns.map((p) => p.id)}
      handler={(e) => userPrefs.set({ [idKey]: e.target.value })}
      label={
        label || (
          <FormattedMessage
            id="label-charging-pattern"
            defaultMessage={'Charging Pattern'}
            description="Charging Pattern"
          />
        )
      }
    />
  );
};

export default SelectChargingPattern;
